import { UPDATE_USER_PAYMENT_INFO } from './types';

const updateUserPaymentInfo = ({
  nameOnCard,
  creditCardNumber,
  expirationMonth,
  expirationYear,
  ccSecurityCode,
  billingAddress,
  distinctBillingAddress,
}) => {
  const {
    street1,
    street2,
    city,
    state,
    postalCode,
    phoneNumber,
    emailAddress,
    fullName,
  } =
    billingAddress || {};

  return {
    type: UPDATE_USER_PAYMENT_INFO,
    payload: {
      nameOnCard,
      creditCardNumber,
      expirationMonth,
      expirationYear,
      ccSecurityCode,
      billingAddress: !distinctBillingAddress
        ? null
        : {
            street1,
            street2,
            city,
            state,
            postalCode,
            phoneNumber,
            emailAddress,
            fullName,
          },
    },
  };
};

export default updateUserPaymentInfo;



// WEBPACK FOOTER //
// ./src/actions/userInformation/updateUserPaymentInfo.js